import React, { useState } from "react";

import CarouselSteps from "../../ui_atoms/CarouselSteps";
import VStack from "../../ui_atoms/VStack";
import { Button, View } from "react-native";
import type { Meta, StoryObj } from "@storybook/react";
import Gap from "../../ui_atoms/Gap";

function CarouselStepsStory() {
    const [index, setIndex] = useState(5);
    return (
        <VStack
            gap={0.5}
            style={{
                margin: 10,
                alignSelf: "center",
            }}
        >
            <View style={{ flexDirection: "row", alignSelf: "center" }}>
                <CarouselSteps count={10} index={index} />
            </View>
            <View style={{ flexDirection: "row", alignSelf: "center" }}>
                <Button
                    title="-"
                    onPress={() => {
                        void setIndex((idx) => {
                            return Math.max(0, idx - 1);
                        });
                    }}
                />
                <Button
                    title="+"
                    onPress={() => {
                        void setIndex((idx) => {
                            return Math.min(9, idx + 1);
                        });
                    }}
                />
            </View>
            <Gap gap={2} />
            <View style={{ flexDirection: "row", alignSelf: "center" }}>
                <CarouselSteps count={10} index={2} />
            </View>
            <View style={{ flexDirection: "row", alignSelf: "center" }}>
                <CarouselSteps count={5} index={4} />
            </View>
        </VStack>
    );
}

const meta = {
    title: "Atom/CarouselSteps",
    component: CarouselStepsStory,
    argTypes: {},
} satisfies Meta<typeof CarouselStepsStory>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {
    args: {},
};
